export const AUTH_DOMAINS = {
    DEVELOPMENT: "betterspace360dev.b2clogin.com", // this url will change once the MS support answered 
    STAGING: "bs360stag.b2clogin.com",
    PRODUCTION: "bs360prod.b2clogin.com",
};

export const AUTH_AD_NAMES = {
    DEVELOPMENT: "betterspace360dev",
    STAGING: "bs360stag",
    PRODUCTION: "bs360prod",
};

export const AUTH_CLIENT_IDS = {
    DEVELOPMENT: "8dd26350-96e9-4438-84a1-7bae11b29a47",
    STAGING: "17f4511e-e3ac-455e-912c-87ca683186d8",
    PRODUCTION: "60fdbfd3-8dd9-41cd-8a5f-6d1074416313",
};

// https://learn.microsoft.com/en-us/azure/active-directory/develop/reference-error-codes
export const AUTH_ERROR_CODES = {
    FORGOT_PASSWORD: "AADB2C90118",
    USER_CANCELLATION: "AADB2C90091",
    NO_EXISTING_SESSION: "AADB2C90077",
};
